import { FC, ReactNode } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { COLORS } from 'services/constants/colors';

type TPgPanelProps = {
	title?: ReactNode;
	/** Buttons on the right of the title. */
	actions?: ReactNode;
	children?: ReactNode;
	/** Inner padding of the body; tables use `0`. */
	bodyPadding?: number | string;
};

/** Paper block with a title bar, used by the settings forms and tables. */
export const PgPanel: FC<TPgPanelProps> = ({ title, actions, children, bodyPadding = 2 }) => (
	<Paper sx={{ mb: 2, overflow: 'hidden' }}>
		{(title || actions) && (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'space-between',
					alignItems: 'center',
					gap: 1,
					flexWrap: 'wrap',
					backgroundColor: COLORS.BACKGROUND_SECONDARY,
					p: '4px 12px',
					minHeight: '40px',
				}}
			>
				{typeof title === 'string' ? (
					<Typography color="primary" sx={{ fontWeight: 'bold', fontSize: '0.95rem' }}>
						{title}
					</Typography>
				) : (
					(title ?? <span />)
				)}
				{actions && (
					<Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
						{actions}
					</Box>
				)}
			</Box>
		)}
		<Box sx={{ p: bodyPadding }}>{children}</Box>
	</Paper>
);
